import { render } from "./TopicPlace.vue?vue&type=template&id=4553f4d7"
import script from "./TopicPlace.vue?vue&type=script&lang=js"
export * from "./TopicPlace.vue?vue&type=script&lang=js"

import "./TopicPlace.vue?vue&type=style&index=0&id=4553f4d7&lang=scss"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__